import { createKiddoAxios } from "./httpClient";

let apiPromise;
const getApi = async () => {
  if (!apiPromise) {
    apiPromise = createKiddoAxios();
  }
  return apiPromise;
};

export const GetUserList = async ({
  page = 1,
  pageSize = 20,
  search = "",
  includeInactive = false,
} = {}) => {
  const api = await getApi();
  const response = await api.get("/read/GetUserList", {
    params: { page, pageSize, search, includeInactive },
  });
  return response.data;
};

export const UpdateUserAccount = async ({
  userId,
  name,
  email,
  phone,
  userType,
} = {}) => {
  const api = await getApi();
  const payload = { userId, name, email, phone, userType };
  const response = await api.post("/insert/UpdateUserAccount", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const DeleteUserAccount = async ({ userId } = {}) => {
  const api = await getApi();
  const response = await api.post(
    "/insert/DeleteUserAccount",
    { userId },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return response.data;
};
